module.exports = __webpack_public_path__ + "static/s2-staticna-f65f6e76d4a0f3d1b9b46a4e152328c9.png";